import { useContext } from 'react';
import { ProjectStatuses } from 'pages/common/types';
import { useToggleProjectStatus } from 'pages/common/hooks/use-toggle-project-saving';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';

export const useToggleSavedProjectStatus = () => {
  const { data } = useContext(DataContext);

  const { isProjectSaved, saveProject, unsaveProject } = useToggleProjectStatus({
    api: data!.api,
    configurationId: data!.id,
    isOpenFromProject: true,
    isInitialProjectSaved: data?.projectStatus === ProjectStatuses.SAVED,
  });

  return {
    isProjectSaved,
    saveProject,
    unsaveProject,
  };
};
